import i18n from '@/i18n';

import type {
	FollowingBaseInput,
	FollowingLineGeneratorResult,
} from '@/components/following/types';

import { createTextSegment } from './segmentFactory';

export interface NoteFollowingInput extends FollowingBaseInput {
	content?: string;
	noteId?: string;
	logCollaboratorId?: string | null;
}

export const buildFollowingLineNote = (
	input: NoteFollowingInput
): FollowingLineGeneratorResult => {
	const hasNoteContext =
		Boolean(input.noteId?.trim()) || input.logCollaboratorId !== undefined;
	return {
		icon: 'note',
		segments: [createTextSegment(i18n.global.t('following.labels.note.added'))],
		detail: input.detail,
		content: input.content,
		noteContext: hasNoteContext
			? {
					noteId: input.noteId?.trim() || undefined,
					logCollaboratorId: input.logCollaboratorId,
				}
			: undefined,
	};
};
